<template>
  <v-app-bar
    color="darkBlue"
    dark
    app
  >
    <div class="container align-center d-flex">

      <v-toolbar-title>
        <router-link :to="{ name: 'products'}" style="text-decoration: none; color: inherit;">
          <v-list-item>
            <v-img
              maxWidth="30"
              src="../assets/preventia3dotsW32.png"
            />
            <v-list-item-title class="ml-4 font-weight-black" style="font-size: 1.1rem" color="#01">
              preventia
            </v-list-item-title>
          </v-list-item>

        </router-link>
      </v-toolbar-title>

      <v-spacer />

      <!-- <v-btn icon @click="goToOrderHistory">
        <v-icon>
          mdi-account
        </v-icon>
      </v-btn> -->
      <v-btn icon @click="openCart">
        <v-badge
          :content="itemsInCart"
          :value="itemsInCart"
          color="green"
          overlap
        >
          <v-icon>
            mdi-cart-outline
          </v-icon>
        </v-badge>
      </v-btn>
      <!-- todo logout not needed because only path to login right now is through sso -->
      <!-- <v-btn icon dark @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn> -->
    </div>
  </v-app-bar>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'TopNavBar',
  methods: {
    openCart: function () {
      this.$emit('openCart');
    },
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push({
            path: '/login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        });
    },
    goToOrderHistory: function () {
      this.$router.push({
        path: '/orders'
      });
    }
  },
  computed: {
    itemsInCart: function () {
      if (this.data) {
        let ret = 0;
        for (const item of this.data) {
          ret += item.quantity;
        }
        return ret;
      }
      return 0;
    },
    ...mapState('cart', ['data'])
  }
};
</script>
